import React from "react";
import styled, { device, themeGet, css } from "../../../styles";
import { Anchor } from "../../UI/Anchor";

export const StyledEmptySpace = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
`;

export const StyledBtnWrap = styled.div`
  margin-top: 20px;
  ${device.small} {
    margin-top: 0;
  }
`;
